window.UpdateDirectDebitCollection = (function ($) {
    let self = {
        elements: {
            UpdateForm: '#direct-debit-collection',
            selectBox: {
                collectionDate: '#direct-debit-collection-select'
            },
            messages: {
                invalidDataError: '#direct-debit-collection-error'
            },
            button: {
                UpdateDetails: '#submit'
            }
        },
        urls: {
            UpdateCollectionDate: '/api/sitecore/UpdatePremiumBankCollection/UpdatePremiumBankCollectionDate',
            UpdateCollectionDateSession: '/api/sitecore/UpdatePremiumBankCollection/UpdateCollectionDateSession',
            successPageUrl: '/my-account/security/request-collection-date-change/request-submitted',
            errorPageUrl: '/error/error-page'
        },
        css: {
            invalidFormInput: 'vds-form__input--invalid'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.UpdateForm).on('submit', self.func.handleContinue);
            },
            handleContinue: function (event) {
                event.preventDefault();
                const collectionDate = $(self.elements.selectBox.collectionDate).val();
                if (collectionDate !== '') {
                    const requestData = {
                        collectionDate: collectionDate
                    };

                    $.ajax({
                        url: self.urls.UpdateCollectionDate,
                        type: 'PATCH',
                        contentType: 'application/json',
                        data: JSON.stringify(requestData),
                    })
                        .done(function (response) {
                            if (response.statusCode.toLowerCase() === self.statusDescription.accepted) {
                                $.ajax({
                                    url: self.urls.UpdateCollectionDateSession,
                                    type: 'POST',
                                    contentType: 'application/json',
                                    data: JSON.stringify({ collectionDate: collectionDate }),
                                })
                                    .done(function () {
                                        window.location.href = self.urls.successPageUrl;
                                    })
                                    .fail(function () {
                                        window.location.href = self.urls.errorPageUrl;
                                    });
                            } else {
                                window.location.href = self.urls.errorPageUrl;
                            }
                        })
                        .fail(function () {
                            window.location.href = self.urls.errorPageUrl;
                        });
                }
            }
        }
    };

    return {
        Init: self.func.init
    };
})(jQuery);

$(document).ready(function () {
    if ('direct-debit-collection' === $('#direct-debit-collection').data('feature')) {
        window.UpdateDirectDebitCollection.Init();
    }
});
